import type { ChatMessage } from "./api/types";

/** Where the "earlier turns summarized" divider goes: after the last message
 *  the thread's running summary covers (`summary_through` in its state,
 *  docs/design/context.md). The model is sent the summary instead of the
 *  messages above the line; the transcript still shows them. -1 for none. */
export function summaryDividerAfter(
  messages: ChatMessage[],
  through: unknown,
): number {
  if (typeof through !== "string" || through === "") return -1;
  return messages.findIndex((m) => m.id === through);
}
